import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

import { CreditPackType } from '@app/models';
import { AppService, ErrorHandlerService, PaymentService } from '@app/services';
import { LoaderService } from '@app/shared';
import { LdecimalPipe } from '@app/shared/pipes';

export interface ModalPublicProperties {
  currencyCode: string;
}

@Component({
  selector: 'app-custom-credit-pack-modal',
  templateUrl: './custom-credit-pack-modal.component.html',
  styleUrls: ['./custom-credit-pack-modal.component.scss'],
  providers: [LdecimalPipe],
  standalone: false
})
export class CustomCreditPackModalComponent implements OnInit {
  @Input() currencyCode: string;
  isLoading = false;
  min = 1000;
  max = 10000;
  step = 1;
  quantity = 3000;
  amountPerCredit = 7;

  constructor(
    public modal: NgbActiveModal,
    public appService: AppService,
    private errorHandlerService: ErrorHandlerService,
    private paymentService: PaymentService,
    private loaderService: LoaderService,
    private ldecimal: LdecimalPipe
  ) {}

  ngOnInit(): void {
    this.loaderService.show();
    this.loadCreditsData();
  }

  loadCreditsData(isConfirm = false) {
    this.isLoading = true;

    this.paymentService
      .creditPackByQuantity({ quantity: this.quantity })
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: creditPack => {
          if (!creditPack) return;

          if (isConfirm) {
            this.modal.close(creditPack);
          } else {
            this.setAmountPerCredit(creditPack);
          }
        },
        error: error => this.errorHandlerService.handle(error)
      });
  }

  setAmountPerCredit(creditPack: CreditPackType) {
    const amount = creditPack.is_promo && this.appService.isEventSale() ? creditPack.amount_promo : creditPack.amount;
    this.amountPerCredit = amount / 100;
  }

  get totalCost(): number {
    return (this.amountPerCredit || 0) * this.quantity;
  }

  valueFormatter = (value: number) => this.ldecimal.transform(value);

  close() {
    this.modal.dismiss();
  }

  confirm() {
    this.loadCreditsData(true);
  }
}
